import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { DepartmentEntity } from "../department/department.entity";
import { divisionEntity } from "../division/division-entity";
import { DriverEntity } from "../drivers/driver-entity";
import { LocationsEntity } from "../locations/locations.entity";
import { RoleEntity } from "../roles/role-entity";
import { VehicleEntity } from "../vehicle/vehicle.entity";
import { VendorEntity } from "../vendor/vendor.entity";
import { RootWiseCostEntity } from "../root-wise-cost/root-wise-cost.entity";

@Entity('plants')

export class PlantsEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "plant_id"
    })
    plantId: number;

    @Column('varchar', {
        name: 'plant_code',
        nullable: true
    })
    plantCode: string;

    @Column('varchar', {
        name: 'plant_name',
        nullable: true
    })
    plantName: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
  
    @OneToMany(() => DepartmentEntity, (dep) => { dep.departmentName }, { cascade: true })
    departmentInfo: DepartmentEntity;

    @OneToMany(() => divisionEntity, (div) => { div.division }, { cascade: true })
    divisionInfo: divisionEntity;

    @OneToMany(() => DriverEntity, (dr) => { dr.name }, { cascade: true })
    driversInfo: DriverEntity;

    @OneToMany(() => LocationsEntity, (loc) => { loc.locationName }, { cascade: true })
    locationsInfo: LocationsEntity;

    @OneToMany(() => VehicleEntity, (veh) => { veh.vehicleName }, { cascade: true })
    vehiclesInfo: VehicleEntity;

    @OneToMany(() => VendorEntity, (ven) => { ven.vendorName }, { cascade: true })
    vendorsInfo: VendorEntity;
    @OneToMany(() => RootWiseCostEntity, (ven) => { ven.routeType }, { cascade: true })
    rootwiseInfo: RootWiseCostEntity;

    
}